export const handleSetOpenCustomSnackbar = (open, data) => ({
    type: 'SET_OPEN_CUSTOM_SNACKBAR', open, data
});
